/**
 * DOS518 — Integrazione ASTUTO
 * csvParser.ts — Parser CSV per export ASTUTO.
 * Formato: sezioni [PERSONALE], [MEZZI_TERRESTRI], [MEZZI_AEREI]
 *          + metadati chiave=valore nella parte superiore.
 */

import type { AstutoIntervento } from '../types';

export function parseCSV(content: string): AstutoIntervento {
  const lines = content.split(/\r?\n/).filter((l) => l.trim());
  const sep = content.includes(';') ? ';' : ',';

  const intervento: AstutoIntervento = {
    personale: [],
    mezziTerrestri: [],
    mezziAerei: [],
  };

  let sezione = '';
  let headers: string[] = [];

  for (const line of lines) {
    const trimmed = line.trim();

    // Intestazione sezione [NOME]
    if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
      sezione = trimmed.slice(1, -1).toUpperCase();
      headers = [];
      continue;
    }

    // Metadati intervento (chiave=valore, fuori sezione)
    if (trimmed.includes('=') && sezione === '') {
      const [key, val] = trimmed.split('=').map((s) => s.trim());
      const k = key.toUpperCase();
      if (k.includes('LAT'))                              intervento.latitudine  = val;
      else if (k.includes('LON'))                         intervento.longitudine = val;
      else if (k.includes('COMUNE'))                      intervento.comune      = val;
      else if (k.includes('CODICE') || k.includes('ID'))  intervento.codice      = val;
      else if (k.includes('DATA'))                        intervento.data        = val;
      else if (k.includes('ORA'))                         intervento.ora         = val;
      else if (k.includes('LOCALITA'))                    intervento.localita    = val;
      continue;
    }

    const cols = trimmed.split(sep).map((c) => c.trim().replace(/^"|"$/g, ''));

    // Prima riga dopo sezione = intestazione colonne
    if (headers.length === 0 && sezione !== '') {
      headers = cols.map((h) => h.toUpperCase());
      continue;
    }

    const row: Record<string, string> = {};
    headers.forEach((h, i) => { row[h] = cols[i] ?? ''; });

    if (sezione === 'PERSONALE' || sezione === 'OPERATORI') {
      intervento.personale.push({
        matricola: row['MATRICOLA'] || row['ID'],
        nome:      row['NOME']      || row['NAME']    || '',
        cognome:   row['COGNOME']   || row['SURNAME'] || '',
        qualifica: row['QUALIFICA'] || row['RUOLO']   || '',
        telefono:  row['TELEFONO']  || row['CELLULARE']|| '',
        radio:     row['RADIO']     || row['CANALE']  || '',
        ente:      row['ENTE']      || '',
      });
    } else if (sezione === 'MEZZI_TERRESTRI' || sezione === 'MEZZI TERRESTRI') {
      intervento.mezziTerrestri.push({
        sigla: row['SIGLA']   || row['CODICE'] || row['ID'] || '',
        tipo:  row['TIPO']    || row['TIPOLOGIA'] || '',
        targa: row['TARGA']   || '',
        ente:  row['ENTE']    || row['PROVENIENZA'] || '',
      });
    } else if (sezione === 'MEZZI_AEREI' || sezione === 'MEZZI AEREI') {
      intervento.mezziAerei.push({
        sigla:   row['SIGLA']   || row['CODICE'] || row['ID'] || '',
        tipo:    row['TIPO']    || '',
        modello: row['MODELLO'] || '',
      });
    }
  }

  return intervento;
}
